var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedoThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07861 10.1606C1.07861 12.9658 2.91699 14.8335 6.19824 14.8335H7.89014C8.29297 14.8335 8.55664 14.5405 8.55664 14.1816C8.55664 13.8228 8.29297 13.5298 7.89014 13.5298H6.20557C3.70801 13.5298 2.38232 12.0649 2.38232 10.0874C2.38232 8.11719 3.70801 6.74023 6.20557 6.74023H11.23L12.9512 6.66699L11.5596 7.85352L9.4502 9.91162C9.33301 10.0288 9.27441 10.168 9.27441 10.3584C9.27441 10.7393 9.53076 11.0029 9.91895 11.0029C10.0801 11.0029 10.2705 10.9297 10.395 10.7979L14.7017 6.57178C14.8481 6.43262 14.9214 6.26416 14.9214 6.08838C14.9214 5.90527 14.8481 5.73682 14.7017 5.59766L10.395 1.37158C10.2705 1.24707 10.0801 1.1665 9.91895 1.1665C9.53076 1.1665 9.27441 1.43018 9.27441 1.81104C9.27441 2.00146 9.33301 2.14062 9.4502 2.25781L11.5596 4.32324L12.9512 5.50977L11.23 5.4292H6.31543C2.96826 5.4292 1.07861 7.36279 1.07861 10.1606Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedoThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RedoThin.f16b2264b9e8cac4ab9efe2b94436ece.svg";